import {
  NOTIFICATION_ICON,
  NOTIFICATION_KIND,
  NOTIFICATION_TARGET,
  NOTIFICATION_TITLE_SOURCE,
} from "../constants";

const CHAT_PRESENTATION = {
  icon: NOTIFICATION_ICON.AVATAR,
  titleSource: NOTIFICATION_TITLE_SOURCE.SENDER,
  titleClassName: "text-gray-800",
  showsSubtitle: true,
  target: NOTIFICATION_TARGET.TENDER_CHAT,
  dismissesOnClick: true,
};

const PDF_PRESENTATION = {
  icon: NOTIFICATION_ICON.PDF,
  titleSource: NOTIFICATION_TITLE_SOURCE.LOCALIZED_MESSAGE,
  titleClassName: "text-gray-800",
  showsSubtitle: false,
  target: NOTIFICATION_TARGET.NONE,
  dismissesOnClick: false,
};

const PRESENTATION_BY_KIND = {
  [NOTIFICATION_KIND.PDF_GENERATION_REQUIRED]: PDF_PRESENTATION,
  [NOTIFICATION_KIND.PDF_READY]: PDF_PRESENTATION,
  [NOTIFICATION_KIND.PDF_GENERATION_FAILED]: PDF_PRESENTATION,

  [NOTIFICATION_KIND.ACCESS_GRANTED]: {
    icon: NOTIFICATION_ICON.ACCESS_GRANTED,
    titleSource: NOTIFICATION_TITLE_SOURCE.STATIC,
    titleKey: "main.notifications.titles.accessGranted",
    titleFallback: "Access granted",
    titleClassName: "text-green-600",
    showsSubtitle: false,
    target: NOTIFICATION_TARGET.PROJECT,
    dismissesOnClick: true,
  },

  [NOTIFICATION_KIND.ACCESS_REVOKED]: {
    icon: NOTIFICATION_ICON.ACCESS_REVOKED,
    titleSource: NOTIFICATION_TITLE_SOURCE.STATIC,
    titleKey: "main.notifications.titles.accessRevoked",
    titleFallback: "Access revoked",
    titleClassName: "text-red-600",
    showsSubtitle: false,
    target: NOTIFICATION_TARGET.NONE,
    dismissesOnClick: true,
  },
};

export function resolveNotificationPresentation(kind) {
  return Object.prototype.hasOwnProperty.call(PRESENTATION_BY_KIND, kind)
    ? PRESENTATION_BY_KIND[kind]
    : CHAT_PRESENTATION;
}
